export default __webpack_public_path__ + "static/media/imgIco01.7d91bd0a.webp";